<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col" v-for=" (item, index) in handleData" :key='index'>
      <div class="card-panel">
        <div class="card-panel-description">
          <div class="card-panel-text">{{item.title}}</div>
          <count-to :start-val="0" :end-val="item.num" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import CountTo from 'vue-count-to';

  export default {
    components: {
      CountTo,
    },
    // 接受父组件的值
    props: {
      handleData: {
        type: Array,
        default: () => [],
				required: true
      }
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .panel-group {
    margin-top: 18px;

    .card-panel-col {
      margin-bottom: 32px;
    }

    .card-panel {
      height: 108px;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: -webkit-linear-gradient(bottom, rgba(41, 99, 206, 0.15), rgba(82, 177, 214, 0), rgb(139, 190, 238)) no-repeat;
      box-shadow: 4px 4px 40px rgba(224, 72, 143, 0.05);
      border-color: rgba(16, 13, 22, 0.363);

      .card-panel-description {
        text-align: center;
        font-weight: bold;
        margin: 26px;
        // margin-left: 0px;

        .card-panel-text {
          line-height: 18px;
          text-align: center;
          color: rgba(0, 0, 0, 0.45);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }

  @media (max-width: 550px) {
    .card-panel-description {
      display: none;
    }
  }
</style>
